<template>
  <div class="table_box">
    <el-table :data="tableData">
      <el-table-column prop="date" :label="$t('common.campaignStatus')" class="table-header-cell">
        <template slot-scope="scope">
          <div>
            <CircleIcon :color="statusColor(scope.row.status)" />
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.pause')">
        <template slot-scope="scope">
          <CustomSwitch
            :value="scope.row.isPause"
            activeColor="#e91545"
            inactiveColor="#d1d1d1"
            :disabled="scope.row.isPause === null || scope.row.status === 'OO'"
            @change="e => accountStateChange(e, scope.row.id)"
          ></CustomSwitch>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.accountNumber')">
        <template slot-scope="scope">{{ scope.row.mt4Account }}</template>
      </el-table-column>
      <el-table-column :label="$t('common.accountType')">
        <template slot-scope="scope">{{ scope.row.accountType }}</template>
      </el-table-column>
      <el-table-column :label="`${$t('common.column.equity')} (${$t('promotion.redepositBonus.usd')})`">
        <template slot-scope="scope">
          <span v-if="scope.row.equity">{{ scope.row.equity | formatNumber(2) }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.column.leverage')">
        <template slot-scope="scope">
          <span v-if="scope.row.leverage">
            {{ scope.row.leverage | formatNumber(2) }}
            <triangle />
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <div slot="empty" class="empty">
        <img class="noData_icon" src="@/assets/images/no_data.png" alt />
        <div>{{ $t('loyalty.noData') }}</div>
      </div>
    </el-table>
    <PopOut
      :visible.sync="pauseCampaignVisible"
      :message="$t('promotion.redepositBonus.dialog.pauseCampaign.desc')"
      :confirmText="$t('promotion.redepositBonus.dialog.pauseCampaign.confirm')"
      @confirm="pauseCampaign"
    ></PopOut>
  </div>
</template>

<script>
import Triangle from '@/components/icon/Triangle.vue';
import CustomSwitch from '@/components/switch/Switch.vue';
import CircleIcon from '@/components/icon/Circle.vue';
import PopOut from './PopOut';
import { apiPauseOrStartCampaign } from '@/resource';

export default {
  name: 'AccountInfoTable',
  props: { tableData: Array, campaignId: Number },
  components: { Triangle, CustomSwitch, CircleIcon, PopOut },
  data() {
    return {
      pauseCampaignVisible: false,
      selectedId: ''
    };
  },
  methods: {
    accountStateChange(state, id) {
      this.selectedId = id;
      if (!state) {
        this.pauseCampaignVisible = true;
      } else {
        this.pauseCampaign();
      }
    },
    pauseCampaign() {
      let body = {
        id: this.selectedId,
        campaignId: this.campaignId
      };
      apiPauseOrStartCampaign(body)
        .then(resp => {
          if (resp.data.data) {
            let index = this.tableData.findIndex(f => f.id === this.selectedId);
            this.tableData[index].isPause = !this.tableData[index].isPause;
            this.tableData[index].status = resp.data.data.status;
            this.$message({
              message: this.$t('common.field.successful'),
              type: 'success'
            });
            this.$emit('stateChange');
          }
        })
        .catch(e => {
          console.log(e);
          this.$message({
            message: this.$t('common.field.failed'),
            type: 'error'
          });
        });
    },
    statusColor(state) {
      let color = '#d1d1d1';
      switch (state) {
        case 'S':
        case 'OO':
          // Grey
          color = '#d1d1d1';
          break;
        case 'OI':
        case 'E':
        case 'WD':
        case 'CV':
        case 'X':
        case 'ER':
          // Blue
          color = '#0051ff';
          break;
        case 'PS':
          // Red
          color = '#e91545';
          break;
      }
      return color;
    }
  }
};
</script>

<style lang="scss" scoped>
.table_box {
  & thead {
    font-family: PingFangSC-Light;
    font-size: 14px;
  }
}

/deep/.el-table__body {
  font-family: Oblivian;
  font-size: 14px;
  font-weight: normal;
  color: $broker-black;
}

/deep/.cell {
  text-align: center;
  align-self: end;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
</style>
